// Title y description por defecto de /impulsadoras-promotoras. Aparte del contenido porque los usa
// el head() de la ruta, que queda en el chunk de entrada: importarlos desde el archivo del contenido
// metía el contenido entero en todas las páginas públicas.

/** Defaults compartidos por la ruta pública y el inventario del panel SEO. */
export const seo = {
  title: "Impulsadoras y Promotoras BTL en Lima para Eventos | Improve",
  description:
    "Impulsadoras y promotoras BTL en Lima: impulsación en punto de venta, eventos y ferias. Selección, capacitación y supervisión. Solicita tu propuesta.",
};
